export const initWalletManager = (useStaging, downPaymentPercent, tenant) => {
	// eslint-disable-next-line
	window.walletManager = new walletManager({
		environment: useStaging ? 'staging' : 'prod',
		walletDefaults: {
			downPaymentPercent: downPaymentPercent || 0.2,
			tenant: tenant || '',
		}
	});
}
